/**
 * @generated SignedSource<<3e7cd2360aec517394f6f980f0586414>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ChargePaymentStatus = "AUTO_CHARGE" | "CANCELED" | "FULLY_REFUNDED" | "MARKED_PAID" | "NO_CHARGES" | "PAID" | "PARTIALLY_PAID" | "PARTIALLY_REFUNDED" | "PROCESSING" | "UNKNOWN" | "UNPAID";
export type LineItemGroupType = "BOOKING" | "EVENT_REGISTRATION" | "EVENT_SIGN_UP" | "PLAYER" | "TRANSPORTATION";
export type LineItemType = "BASIC" | "BOOKING" | "EVENT_REGISTRATION" | "EVENT_SIGN_UP" | "NO_SHOW_BOOKING" | "NO_SHOW_ROUND" | "ROUND";
export type OrderStatus = "CANCELED" | "DRAFT" | "EMPTY" | "FULLY_PAID" | "FULLY_REFUNDED" | "OPEN" | "PARTIALLY_PAID" | "PARTIALLY_REFUNDED";
import { FragmentRefs } from "relay-runtime";
export type useGetLineItemsAndPriceForRound_Round$data = {
  readonly booking: {
    readonly orders: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly id: string;
          readonly lineItemGroups: ReadonlyArray<{
            readonly id: string;
            readonly lineItems: ReadonlyArray<{
              readonly __typename: string;
              readonly appliedDiscounts?: ReadonlyArray<{
                readonly amountCents: number | null | undefined;
                readonly squareExternalDiscountId: string | null | undefined;
              } | null | undefined> | null | undefined;
              readonly id: string;
              readonly name: string;
              readonly price: number;
              readonly type: LineItemType;
            } | null | undefined> | null | undefined;
            readonly round: {
              readonly id: string;
            } | null | undefined;
            readonly type: LineItemGroupType;
          } | null | undefined> | null | undefined;
          readonly orderDiscounts: {
            readonly edges: ReadonlyArray<{
              readonly node: {
                readonly amount: number | null | undefined;
                readonly appliedAmount: number | null | undefined;
                readonly id: string;
                readonly lineItemGroupId: string | null | undefined;
                readonly name: string;
                readonly squareExternalId: string | null | undefined;
              } | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
          readonly status: OrderStatus | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  };
  readonly paymentStatus?: ChargePaymentStatus;
  readonly " $fragmentType": "useGetLineItemsAndPriceForRound_Round";
};
export type useGetLineItemsAndPriceForRound_Round$key = {
  readonly " $data"?: useGetLineItemsAndPriceForRound_Round$data;
  readonly " $fragmentSpreads": FragmentRefs<"useGetLineItemsAndPriceForRound_Round">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AppliedDiscount",
    "kind": "LinkedField",
    "name": "appliedDiscounts",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amountCents",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "squareExternalDiscountId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useGetLineItemsAndPriceForRound_Round",
  "selections": [
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "paymentStatus",
          "storageKey": null
        }
      ],
      "type": "CustomerRound",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "booking",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrderConnection",
          "kind": "LinkedField",
          "name": "orders",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrderEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Order",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "status",
                      "storageKey": null
                    },
                    (v0/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "LineItemGroup",
                      "kind": "LinkedField",
                      "name": "lineItemGroups",
                      "plural": true,
                      "selections": [
                        (v0/*: any*/),
                        (v1/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "round",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/)
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "lineItems",
                          "plural": true,
                          "selections": [
                            (v0/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "__typename",
                              "storageKey": null
                            },
                            (v1/*: any*/),
                            (v2/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "price",
                              "storageKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v3/*: any*/),
                              "type": "RoundLineItem",
                              "abstractKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": (v3/*: any*/),
                              "type": "BookingLineItem",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "OrderDiscountConnection",
                      "kind": "LinkedField",
                      "name": "orderDiscounts",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "OrderDiscountEdge",
                          "kind": "LinkedField",
                          "name": "edges",
                          "plural": true,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "OrderDiscount",
                              "kind": "LinkedField",
                              "name": "node",
                              "plural": false,
                              "selections": [
                                (v0/*: any*/),
                                (v2/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "appliedAmount",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "amount",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "squareExternalId",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "lineItemGroupId",
                                  "storageKey": null
                                }
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Round",
  "abstractKey": "__isRound"
};
})();

(node as any).hash = "dc8bca2f506fff7985db39d9835993fe";

export default node;
